import { render } from "./Chat.vue?vue&type=template&id=4ad35d58&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=4ad35d58&scoped=true&lang=css"
import "./Chat.vue?vue&type=style&index=1&id=4ad35d58&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad35d58"]])

export default __exports__